module.exports = __webpack_public_path__ + "img/03.b55cf954.png";